import nbrApi from './nbrApi';

// Generic API methods that maintain the same interface
export const ApiService = {
  get: async (endpoint, config = {}) => nbrApi.get(endpoint, config),
  post: async (endpoint, data = {}, config = {}) => nbrApi.post(endpoint, data, config),
  put: async (endpoint, data = {}, config = {}) => nbrApi.put(endpoint, data, config),
  delete: async (endpoint, config = {}) => nbrApi.delete(endpoint, config),
  patch: async (endpoint, data = {}, config = {}) => nbrApi.patch(endpoint, data, config),
  request: async (config) => nbrApi.request(config)
};

export default ApiService;
